<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
<div style="text-align: left;">
  
<div class=" margin-bottom-xs">
    <img class="class-img" :src="courseObj.img"/>
    <div class="flex bg-white padding-top padding-lr ">
        <div class=" text-bold text-xl text-black text-cut " style="width:600px;text-align: left;"> {{courseObj.name}}</div>
    </div>
    <div class="b-b bg-white flex align-center justify-between padding">
        <div class=" flex align-center">
            <div class="text-red text-bold " style="font-size: 25px !important; letter-spacing:2px;">
                ¥{{courseObj.currentPrice/100}} </div>
            <div style="text-decoration:line-through;letter-spacing:2px;" class=" text-sm margin-left-sm">
                ¥{{courseObj.price/100}}
            </div>
        </div>
        <div class="text-sm text-gray">已更{{courseObj.hasClasses}}节</div>
        <div class="text-sm text-gray">
            <span class="cuIcon-hotfill text-red" style=" font-size: 15px !important;"></span>
            {{courseObj.heat}}人已购买
        </div>
    </div>

    <div class=" flex align-center  justify-between align-center bg-white padding b-b" @click="showModal">
        <div class="bz text-xs">保障</div>
        <div class="text-bold xfbz" > 高清视频 · 版权保护 · 消费者保障服务 　 </div>
        <span class="cuIcon-right text-gray" style="font-size: 36px !important;"></span>
    </div>
    <div class=" flex justify-between align-center bg-white padding padding-tb-sm margin-bottom-xs" @click="showModal2" v-if="courseObj.relatedOneName">
        <div class="zeng text-xs ">赠</div>
        <div class="text-sm text-cut" style="width: 500px;">购买即送《{{courseObj.relatedOneName}}》等课程</div>
        <span class="cuIcon-right text-gray" style="font-size: 36px !important;"></span>
    </div>

    <div class=" flex align-center bg-white padding justify-between" >
        <div class="teacher-info flex align-center">
            <img class="teacher-img" :src="courseObj.lecturer.img"/>
            <div style="width:300px;">
                <div style="width: 300px;" class="text-cut text-xl text-bold text-black">{{courseObj.lecturer.name}}
                </div>
                <div class="user-ch margin-top-xs" v-for="(item, index) in lecturerObj.tags" :key="index" >{{item.tagName}}</div>
            </div>
        </div>
        <!-- <div class="more">查看更多</div> -->
    </div>
</div>



<div class="downp">
    <div  class="nav ">
        <div class="text-center flex align-center justify-between padding-lr">
            <div class="cu-item " :class="currentTab==0 ? 'on on1' : ''"  @click="swichNav(0)">
                课程简介</div>
            <div class="cu-item " :class="currentTab==1 ? 'on on2' : ''"  @click="swichNav(1)">
                课程目录({{courseObj.sunClasses}})</div>
            <div class="cu-item " :class="currentTab==2 ? 'on on1' : ''"  @click="swichNav(2)">
                课程评价</div>
        </div>
    </div>
    <div class="xq" v-if="currentTab==0">
        <div class="xq-detail">
            <div class="xq-js">课程介绍</div>
            <div class="xq-li bg-white">
                <div class="xq-title">教学形式</div>
                <div class="xq-info">{{courseObj.teachType}}</div>
            </div>
            <div class="xq-li">
                <div class="xq-title">适用人群</div>
                <div class="xq-info">{{courseObj.forPeople}}</div>
            </div>
            <div class="xq-li bg-white">
                <div class="xq-title">学习形式</div>
                <div class="xq-info">{{courseObj.teachStyle}}</div>
            </div>
            <div class="xq-li">
                <div class="xq-title"><span space="ensp">总&nbsp;&nbsp;课&nbsp;&nbsp;时</span></div>
                <div class="xq-info">{{courseObj.sunClasses}}课时</div>
            </div>
            <div class="xq-li">
                <div class="xq-title">已更课时</div>
                <div class="xq-info">{{courseObj.hasClasses}}课时</div>
            </div>
            <div class="xq-li bg-white">
                <div class="xq-title">学习平台</div>
                <div class="xq-info">{{courseObj.learnPlatform}}</div>
            </div>
            <div class="xq-li">
                <div class="xq-title"><span space="ensp">有&nbsp;&nbsp;效&nbsp;&nbsp;期</span></div>
                <div class="xq-info">{{courseObj.indate}}</div>
            </div>
        </div>
        <div v-if="virtualBuySet" class="nav " style="margin: 0 0 0 30px;">
            <div class="text-center flex col-4">
                <div class="cu-item on on2"  @click="swichNav(0)">
                    最近购买</div>
            </div>
        </div>
        <div v-if="virtualBuySet" class="bg-white item-ranking">
            <swiper vertical="true" autoplay="true" circular="true" interval="1000" style="height:850px;" display-multiple-items="6">
                <swiper-item v-for="(item, index) in robotList" :key="index" >
                    <div class="flex align-center justify-between b-b padding">
                        <div class="flex align-center">
                            <img class="paihangimg" :src="item.img" />
                            <div class="margin-left-xs text-df">{{item.showName}}</div>
                        </div>
                        <div class="text-sm"><span class="text-red">{{item.title}}</span>购买了该课程</div>
                    </div>
                </swiper-item>
            </swiper>
        </div>
        <div class="teacher-js">
            <img mode="widthFix" v-for="(item, index) in testdataList" :key="index"  :src="item"/>
        </div>

        <div class="tip">------------- 课程须知 -------------</div>
        <div class="tip-d">
            <div class="tip-title">
                <img class="tip-img1" src="/img/sp1.png"/>
                <div>购买课程后如何观看？</div>
            </div>
            <div class="tip-info">
                平台搜索【众校云课堂】进入小程序，点击底部【学习】按钮，即可观看已购买课程。
            </div>
        </div>
        <div class="tip-d">
            <div class="tip-title">
                <img class="tip-img1" src="/img/qian.png" />
                <div>购买课程后能否退款？</div>
            </div>
            <div class="tip-info">
                <span class="text-blue">在支付7个自然日内</span>且<span class="text-blue">学习进度小于5%</span>的订单，可以在我的订单里发起退款申请，审核通过后将退款并关闭课程学习，退款金额原路返回。<span class="text-blue">支付超过七个自然日或学习进度超过5%则无法发起退款</span>
            </div>
        </div>
        <div class="tip-d">
            <div class="tip-title">
                <img class="tip-img1" src="/img/tuitui.png" />
                <div>售后问题如何咨询？</div>
            </div>
            <div class="tip-info">
                <span class="blue-t">1.</span>若您需要咨询涉及老师课程内容相关，可通过私信职拍视频师进行沟通解答
            </div>
            <div class="tip-info">
                <span class="blue-t">2.</span>若您需要咨询涉及众校云课堂程序使用，可点击页面下【咨询】按钮进行线上反馈。
            </div>
        </div>
        <div class="tip-d">
            <div class="tip-title">
                <img class="tip-img1" src="/img/bzbz.png" />
                <div>购课的权益和保障？</div>
            </div>
            <div class="tip-info">
                具体请查询<span class="text-blue">《付费课程购买协议》</span>，购买课程即代表您已阅读并同意该协议。
            </div>
        </div>
        <div style="height: 20px;"> </div>
    </div>
    <div class="xq" v-if="currentTab==1" >
        
        <div class="align-center justify-between b-b padding" v-for="(item, index) in classList" :key="index" >
            <div class="flex align-center ">
                <div class="">{{index<9?'0':''}}{{index+1}} </div>
                        <div class="padding-left" >
                            <div class="text-cut" style="width: 230px;">{{item.name}}</div>
                            <div class="padding-top-sm"><span class="course-type">{{item.type==1?"视频":"音频"}}</span>
                                {{item.min}}分{{item.sec}}秒
                            </div>
                        </div>
                        <block v-if="payState">
                            <div>
                                <img src="/img/play.png" class="course-img1" />
                            </div>
                        </block>
                        <block v-if="!payState">
                            <div v-if="item.free==1" class="course-play flex align-center justify-center">
                                <img src="/img/play.png" class="course-img"/>试看
                            </div>
                            <div v-if="item.free==0">
                                <img src="/img/suo.png" class="course-img1" />
                            </div>
                        </block>
                </div>
            </div>
        </div>
        <block v-if="currentTab==1">
        <div  class=" b-b padding" v-for="(item, index) in albumList" :key="index" @click='sourcelistshow(index)' >
            <div class="flex align-center justify-between">
                <div class=" flex " >
                    <icon class="cuIcon-title margin-right-sm padding-top-xs" style="font-size: 25px !important;">
                    </icon>
                    <div>
                        <div class="text-bold text-lg">{{item.name}}</div>
                        <div class="text-gray text-sm margin-top-sm padding-bottom-sm">小节共{{item.count}}个</div>
                    </div>
                </div>
                <!-- <icon class="{{expand == index ? 'cuIcon-unfold' : 'cuIcon-right'}} text-gray"
                    style="font-size: 36px !important;"></icon> -->
            </div>
            <div style='padding:0 30px;' v-if="expand == index">
                <div class="flex align-center b-top padding-tb" v-for="(item, index) in albumClassList" :key="index" >
                    <div v-if="index<9?'0':''">{{index+1}} </div>
                    <div class=" margin-left">
                        <div class="text-cut"  style="width: 570px;">{{item.name}}</div>
                        <div class="flex align-center justify-between padding-top-sm">
                            <div class=""><span class="course-type">{{item.type==1?"视频":"音频"}}</span>
                                {{item.min}}分{{item.sec}}秒</div>
                            <block v-if="payState">
                                <div>
                                    <img src="/img/play.png" class="course-img1"/>
                                </div>
                            </block>
                            <block v-if="!payState">
                                <div v-if="item.free==1" class="course-play flex align-center justify-center">
                                    <img src="/img/play.png" class="course-img"/>
                                    试看
                                </div>
                                <div v-if="item.free==0">
                                    <img src="/img/suo.png" class="course-img1"/>
                                </div>
                            </block>
                        </div>
                    </div>
                </div>
            </div>
    
    
          </div>
        </block>

    <div class="xq" v-if="currentTab==2">
        <div class="xq-pj">
            <div class="xq-pj-1">课程评价<span class="xq-pj-11">（{{commentTotal}}）</span></div>
            <div class="xq-pj-2" >
                查看全部></div>
        </div>
    </div>

    
    <div class="zxy " style="padding-top: 30px;">—— 学知识 学技能 就在众校云课堂 ——</div>
    <div style="height:200px"></div>
    <div class=" " style="position: fixed;bottom: 0; width: 100%;background-color: #ffffff;padding: 13px;z-index: 9;">
        <div class="text-center">
            <!-- <div v-if="!payState" class="text-center flex align-center justify-center margin-bottom-sm">
                <label class="ttui-cell">
                    <el-radio class="blue "  @click="changRadio"  value="1" />
                </label>
                <div class="margin-left-xs" >阅读并同意<span class="text-blue">《众校云课堂付费课程购买协议》
                    </span> </div>
            </div> -->
            <div class=" padding-bottom-sm" style="width: 100%;">
                <!-- <button class="tb-area2 pdd" open-type="share" style="padding: 0 10px 0 10px">
                    <img class="dp-img " src="/img/fx.png" />
                    <div>
                        <text space="ensp">
                            <button open-type="share">
                                分 享
                            </button>
                        </text>
                    </div>
                </button>

                <div class="tb-area1 pdd" @click="contact" style="padding: 0 10px 0 10px">
                    <img class="dp-img " src="/img/zx.png"/>
       
                </div> -->

                <!-- <div style="width: 70px;"></div> -->

  
                <!-- <div class="cu-btn btn-gm btn-font" v-if="checkRadio & !payState & skuCount == 0" >立即抢购
                </div>
                <div v-if="!payState & (skuCount > 0 || !checkRadio)" class="cu-btn btn-gm btn-font" @click="getLijiQg">立即抢购
                </div> -->
                <div class="cu-btn btn-gm btn-font" v-if="!payState&&skuList.length>0" style="width: 100%;" @click="showModal1">立即抢购
                </div>
                <div class="cu-btn btn-gm btn-font" v-if="!payState&&skuList.length<1" style="width: 100%;" @click="pageToPay">立即抢购
                </div>
                <div class="cu-btn btn-gm btn-font" v-if="payState" style="width: 100%;" @click="goApp">前往观看
                </div>
            </div>
        </div>
    </div>

</div>

<!-- 不能删是遮盖层 -->
<div v-if="showEnsure" @click="hideModal" class="ensure-sha">
</div>

<!-- 保障 -->
<div v-if="showEnsure" @click="hideModal" class="ensure-info">
    <div class="ensure-t">— 服务说明 —</div>
    <div class="ensure-detail">
        <div class="ensure-detail-n">
            <img src="/img/ffzl.png" class="ensure-detail-img"/>
        </div>
        <div class="ensure-info2">
            <div class="ensure-title">付费专栏</div>
            <div class="ensure-time">永久解锁专栏内所有图文、音频、视频、答题课程</div>
        </div>
    </div>
    <div class="ensure-detail">
        <div class="ensure-detail-n">
            <img src="/img/ffzl.png" class="ensure-detail-img"/>
        </div>
        <div class="ensure-info2">
            <div class="ensure-title">不支持退款</div>
            <div class="ensure-time">该课程购买后不支持退款，请慎重购买</div>
        </div>
    </div>
    <div class="ensure-detail">
        <div class="ensure-detail-n">
            <img src="/img/ffzl.png" class="ensure-detail-img"/>
        </div>
        <div class="ensure-info2">
            <div class="ensure-title">消费者保障服务</div>
            <div class="ensure-time">如商品有质量问题、描述不符等情况，您有权申请退货退款</div>
        </div>
    </div>
    <div class="ensure-detail" >
        <div class="ensure-detail-n">
            <img src="/img/ffzl.png" class="ensure-detail-img"/>
        </div>
        <div class="ensure-info2">
            <div class="ensure-title">商家资质</div>
            <div class="ensure-time">查看商家详细资质信息</div>
        </div>
    </div>
</div>
<!-- 不能删是遮盖层 -->
<div v-if="showEnsure2" @click="hideModal2" class="ensure-sha">
</div>

<!-- 保障 -->
<div v-if="showEnsure2" @click="hideModal2" class="tan2">
    <div class="zeng-bg">赠品课程</div>
    <div class="cu-timeline text-red" v-for="(item, index) in relatedCourseList" :key="index" >
        <div class="cu-item  " style="    padding: 30px 30px 30px 100px;color: #ee0c0c;">
            <div class="content text-left" style="background-color: white;font-size: 27px;color: #222222;padding: 20px 30px;">
                {{item.name}}
            </div>
        </div>
    </div>
</div>

<!-- 不能删是遮盖层 -->
<div v-if="showEnsure1" @click="hideModal1" class="ensure-sha">
</div>

<!-- sku -->
<div v-if="showEnsure1" class="ensure-info">
    <div class="flex justify-between  ">
        <img class="kec-img" :src="courseObj.img"/>
        <div class="column justify-between" style="margin-left: 10px;">
            <div style="width: 266px;" class="flex padding-bottom-xs align-center justify-between ">
                <div style="width: 203px;" class="good-name text-cut ">{{courseObj.categoryName}}</div>
                <div style="font-size: 23px; color: red;" class="text-bold text-right">
                    ￥{{courseObj.currentPrice/100}}
                </div>
            </div>
            <div class="text-gray text-left" style="font-size: 15px;color: #5f5f5f;"> 共 {{courseObj.sunClasses}} 节</div>
            <div style="width: 420px;font-size: 15px;color: #afafaf;" class="  text-gray "><span>{{subSkuList.skuName}}</span> / <span>{{subSkuValueList.skuValue}}</span></div>
        </div>
    </div>
    <div class="bg-white margin-tb-sm b-top padding-top-sm">
        <div class="text-black text-bold text-lg">类型</div>
        <div class="grid col-3 padding-tb-sm">
            <div class="padding-xs" v-for="(item, index) in skuList" :key="index" style="width: 33%;">
                <button style="width: 100%;padding: 0px !important;" class="cu-btn orange lg block " @click="selected(index)"  :class="index==i?'bg-blue':'line-blue'">
                    <div style="width: 200px;" class="text-cut"> <span>{{item.skuName}}</span></div>
                </button>
            </div>
        </div>
        <div class="text-black text-bold text-lg">属性</div>
        <div class="grid col-3 padding-tb-sm">
            <div class="padding-xs" v-for="(item, index) in skuValueList" :key="index"  style="width: 33%;" >
                <button style="width: 100%;padding: 0px !important;" class="cu-btn orange lg block text-cut " @click="selectedT(index)" :class="index==j?'bg-blue':'line-blue'">
                    <div style="width: 200px;" class="text-cut"> <span>{{item.skuValue}}</span></div>
                </button>
            </div>
        </div>
    </div>
    <div class="flex align-center justify-between b-top margin-bottom-xl padding-top-sm">
        <div class="text-bold text-black" style="font-size: 18px;">购买份数</div>
        <div class="text-gray">1 份</div>
    </div>

    <div class="padding-sm bg-skugou round text-white text-center"  @click="pageJumpPay" data-url="/pages/listxiangqing/listxiangqing">立即抢购
    </div>

</div>


</div>
</template>
<script>
var _hmt = _hmt || [];
import wx from 'weixin-js-sdk'
import vueSeamlessScroll from 'vue-seamless-scroll'
import QRCode from 'qrcode'
import axios360 from 'axios'
import md5 from 'js-md5';

export default {
  
  name: 'zxykc',
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      requestHeadUrl: 'https://douyin.kequbang.com',
    //   requestHeadUrl: 'http://localhost:8180',
      currentTab:0,
      showEnsure1: false,
      showEnsure: false,
      showEnsure2: false,
      courseObj: {},
      courseId:"",
      productId:"",
      content:"",
      userImg:"",
      commentTime:"",
      commentTotal:0,
      classList:[],
      system: {},
      robotList:[],
      testdataList:[],
      virtualBuySet:false,
      payState:false,
      flag:"true",
      region: ['江苏省', '南京市', '玄武区'],
      showGiftPhone: true,
      DRParams:{},
      checkRadio:true,
      skuList: [],
      skuValueList: [],
      i:0,
      j:0,
      subSkuList: [],
      subSkuValueList: [],
      skuCount: 0,
      display:'none',
      displaymore:'block',
      displayless: 'none',
      user: '',
      openId: ''
    }
  },
  computed: {
    optionHover () {
      return {
        hoverStop: false, //是否开启鼠标悬停stop
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    const thisObj = this
    var href = window.location.href
    console.log("11111111111")
    console.log(href)
    thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('?')
      //9d03442a91c345709dcbcd85daab9cc4
      // var gid = rr[rr.length-1].split('-')[0]
      // console.log('rr：' + rr)
      var gid = rr[rr.length-1]
      // gid = gid.split('&')[0]
      // console.log('gid：' + gid)
      var wx = window.navigator.userAgent.toLowerCase();
      let params = this.$route.query;
      //  else {
      //   if (params.state!='1') {
      //     location.href = window.location.href + '&state=1'
      //   }
      // }
      this.$root.qhclickid = params.qhclickid
      this.$root.sourceid = params.sourceid
      const thisObj = this
      thisObj.getId = gid
      this.$root.ciphertext = gid
      thisObj.$api.get(thisObj.requestHeadUrl + '/api/order/getCiphertext?ciphertext='+ gid , {}).then(res => {
        console.log(res)
        thisObj.courseObj = res.data
        thisObj.skuList = res.data.attribute
        if (thisObj.skuList.length>0){
          thisObj.subSkuList = res.data.attribute[0]
          thisObj.skuValueList = res.data.attribute[0].skuValueList
          this.subSkuValueList = this.skuValueList[0]
        }
        var cl = res.data.classList
        cl.forEach(e => {
          e.min=parseInt(e.duration / 60)
          e.sec=e.duration % 60
        });
        thisObj.classList = cl
        thisObj.payState = (res.data.purchased=='1')
        thisObj.lecturerObj = res.data.lecturer
        thisObj.testdataList = JSON.parse(res.data.detailImgs)
        console.log("skuValueList")
        thisObj.getLink()
        thisObj.$root.courseObj = res.data
        thisObj.$root.lecturerObj = res.data.lecturer
        // console.log(skuValueList)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    
    unloadHandler() {
      this.leaveFoot()
    },
    getLink() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/api/course/getUrlLinkGenerate?courseId='+ thisObj.courseObj.id, {}).then(res => {
        // console.log(res)
        thisObj.$root.appLink = res.data
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    swichNav: function (currentTab) {
      if (this.currentTab == currentTab) return;
      this.currentTab = currentTab
      this.scrollLeft = (currentTab- 1) * 60
    },
    pageJumpPay(uri) {
      const thisObj = this
      this.$root.subSkuList = thisObj.subSkuList
      this.$root.subSkuValueList = thisObj.subSkuValueList
      thisObj.$router.push({
        path: '/buykc',
        query: {
        }
      })
    },
    pageToPay() {
        const thisObj = this
        thisObj.$router.push({
            path: '/buykc',
            query: {
        }
      })
    },
    goApp() {
      location.href=this.$root.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    showModal() {
      this.showEnsure = true
    }, 
    showModal1() {
      this.showEnsure1 = true
    }, 
    showModal2() {
      this.showEnsure2 = true
    }, 
    hideModal() {
      this.showEnsure = false
    },
    hideModal1() {
      this.showEnsure1 = false
    },
    hideModal2() {
      this.showEnsure2 = false
    },
    // 页面跳转
    pageJump (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes
      
    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    thisObj.userPhone = ''
      let queryData = {
        goodsName: info.goodsName,
        title: goodsAttributes[obj].title,
        values: goodsAttributes[obj].values[index],
        valueKey: goodsAttributes[obj].valueKey[index],
        price: info.groupBuyingPrice,
        oldPrice: info.buyPrice,
        wxCode: that.wxCode,
        getId: that.getId,
        introduceImg: goodsAttributes[obj].imgValue[index]
      }
      thisObj.leaveFoot()
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    pageJumpShop (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes

    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    // thisObj.userPhone = ''
      let queryData = {
        goodsId: info.id,
        lon: that.lon,
        lat: that.lat,
      }
      thisObj.$router.push({
        path: '/yxShop',
        query: queryData
      })
    },
    onClickLeft () {
      this.pageNo = 0
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri, 
        query: queryData
      })
    },
    setBuyList() {
      this.buyList= [{name:'王*',time:1},{name:'张*里',time:1},{name:'王*和',time:2},
      {name:'李*',time:3},{name:'赵*极',time:3},{name:'王*',time:3},{name:'张*',time:4},
      {name:'沈*',time:5},{name:'刘*',time:10},{name:'李*芝',time:10},{name:'赵*',time:11}]
    },
    selectedT(index){
      this.j = index,
      this.subSkuValueList = this.skuValueList[index]
    },
    selected(index){
      let skuValueList = this.skuList[index].skuValueList;
      this.skuValueList = skuValueList,
      this.i =index,
      this.j =0,
      this.subSkuList = this.skuList[index]
    },
  /**
  * 初始化数据
    */
  initDate(e) {
    var that = this
    that.left_time_list = that.formatSeconds(e),
    that.left_time_list_date = that.formatDate(JSON.stringify(that.left_time_list));
    that.left_time = e
  },
  /**
    * 获取指定时间-当前时间的秒数
    * @param {*} end_time 
    */
  getTimestap(end_time) {
    // 当前时间
    var currentTime = parseInt(new Date().getTime() / 1000);
    // 未来时间
    var futureTime = parseInt(new Date(end_time.replace(/-/g, '/')).getTime() / 1000); //ios无法解析
    return futureTime <= currentTime ? 0 : futureTime - currentTime;
  },/**
  * 毫秒-天-时-分-秒
  * @param {*} value 
  */
  formatSeconds(value) {
    let time = [],
      day = parseInt(value / 86400),
      hour = parseInt((value % 86400) / 3600),
      min = parseInt(((value % 86400) % 3600) / 60),
      sec = parseInt(((value % 86400) % 3600) % 60);
    time[0] = day > 0 ? this.addZero(day) : this.addZero(0);
    time[1] = hour > 0 ? this.addZero(hour) : this.addZero(0);
    time[2] = min > 0 ? this.addZero(min) : this.addZero(0);
    time[3] = sec > 0 ? this.addZero(sec) : this.addZero(0);
    return time;
  },
  /**
   * 拆分数组-天-时-分-秒
   * @param {*} e 
   */
  formatDate(e) {
    let list = JSON.parse(e);
    for (let i = 0; i < list.length; i++) {
      list[i] = list[i].toString().split('');
    }
    return list;
  },
  /**
   * 补0
   * @param {*} num 
   */
  addZero(num) {
    return num < 10 ? "0" + num : num;
  },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl {
    font-size: 36px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.an_shop {
  width: 100%;
  line-height: 130px;
  color: #fff;
  background-color: #ec3636;
  border-radius: 30px;
  text-align: center;
  font-size: 48px;
  height: 130px;
}
.onno {
  font-size: 40px;
  border-radius: 30px;
}

.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #f53434;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #f53434;
}
.bg-redler {
    background-color: #ffc0c0;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 10px;
}
.padding-top-sm {
    padding-top: 20px;
}

.cu-modal.show {
    opacity: 1;
    transition-duration: 0.3s;
    -ms-transform: scale(1);
    transform: scale(1);
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: auto;
}
.cu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1110;
    opacity: 0;
    outline: 0;
    text-align: center;
    -ms-transform: scale(1.185);
    transform: scale(1.185);
    backface-visibility: hidden;
    perspective: 2000px;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease-in-out 0s;
    pointer-events: none;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.cu-modal.bottom-modal::before {
    vertical-align: bottom;
}
.cu-modal::before {
    content: "\200B";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}
.cu-modal.bottom-modal .cu-dialog {
    width: 100%;
    border-radius: 0;
}
.cu-dialog {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
    width: 680px;
    max-width: 100%;
    background-color: #f8f8f8;
    border-radius: 10px;
    overflow: hidden;
}
.text-right {
    text-align: right;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.cuIcon-close:before {
    content: "\e646";
}
.text-black, .line-black, .lines-black {
    color: #333333;
}
.text-bold {
    font-weight: bold;
}
.text-center {
    text-align: center;
}
.text-xl {
    font-size: 36px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.padding-lr-sm {
    padding-left: 20px;
    padding-right: 20px;
}
.round {
    border-radius: 500px;
}





button.tools-item {
  line-height: 1.1;
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 24px;
  color: #fff;
  position: fixed;
  bottom: 140px;
  right: 55px;
}

 .tools-item cover-div {
  display: flex;
  align-items: center;
}
 .tools-item cover-image {
  width: 40px;
  margin: 0 12px 0 40px;
}
.kqb-share2 {
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #333;
  position: fixed;
  bottom: 0px;
}
.bgC-white {
  background-color: #fff;
}
[class*="cuIcon1-"] {
  font-family: "myFont";
  font-size: inherit;
  font-style: normal;
}
.daoh {
  height: 50px;
  width: 50px;
  margin-left: 40px;
}
.shop-img {
  width: 140px;
  height: 140px;
  border-radius: 20px;
  margin: 0 10px 0 15px;
}
.cuIcon-locationfill:before {
    content: "\e650";
    font-size: inherit;
    font-style: normal;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.co {
    color: #7eb0f7;
}
.text-gray, .line-gray, .lines-gray {
    color: #aaaaaa;
}
.swiper-img {
  width: 100%;
  height: 550px;
  border-radius:10px;
}




.bannerswipers {
  width: 100% !important;
  height: 500px;
  overflow: hidden;
}

.bannerswipers image {
  display: block;
}

/*用来包裹所有的小圆点  */

.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */

.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

.lunbo {
  height: 520px;
}
image {
 width: 100%;
 height: 500px;
  display: inline-block;
  position: relative;
  z-index: 0;
}
.touxiang{
  width: 80px;
  height: 80px;
}

.cu-item {
  text-align: center;
  display: inline-block;
  min-width: 160px !important;
  color: #999999;
  /* display: flex !important; */
  align-items: center !important;
  justify-content: center !important;
  font-size: 31px;
  font-weight: bolder;
}
/* 弹幕 */

.item-ranking {
  margin: 0 30px 30px 30px;
  border-radius: 30px;
}

.paihangimg {
  height: 60px;
  width: 60px;
  border-radius: 500px;
  margin: 0 10px 0 0;
  background-color: #4ecde4;
}

/* 划线价格 */
.huaxianjia {
  color: #ffffff;
  font-size: 24px;
  padding-top: 58px;
  text-decoration: line-through;
}

.xuanfu-tvimg {
  width: 130px;
  height: 125px;
  position: fixed;
  bottom: 460px;
  z-index: 3;
  right: 35px;
}

.on2::after {
  text-align: center;
  width: 170px;
  height: 8px;
  background-color: #3ea4f8;
  border-radius: 4px;
  content: "";
  position: absolute;
  top: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  opacity: 0.8;
  /* border-bottom: 2px solid #405cfd !important; */
}

.on {
  color: #000;
  font-size: 40px;

}
.time-box {
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  padding: 10px 5px;
  /* background: #fff; */
}

.time-item {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  margin: 0 2px;
  background: #f7f5b4;
  color: #e70f0f;
}

.time-item1 {
  width: 30px;
  height: 40px;
  background: linear-gradient(90deg, #FFEBB1 0%, #FFDB8F 100%);
  border-radius: 4px;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  margin: 0 10px;
}
.bg-red {
    background-color: #e54d42;
    color: #ffffff;
}
.padding-lr-xs {
    padding-left: 12px;
    padding-right: 12px;
}

.justify-between {
    justify-content: space-between;
}

.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.padding-tb-xs {
    padding-top: 12px;
    padding-bottom: 12px;
}
.text-df {
	font-size: 20px;
}
.padding-tb-sm {
	padding-top: 20px;
	padding-bottom: 20px;
}

.padding-tb {
	padding-top: 30px;
	padding-bottom: 30px;
}
.padding-lr {
	padding-left: 30px;
	padding-right: 30px;
}
.seamless-warp {
  height: 550px;
  overflow: hidden;
}
.zhuanshu {
    background-color: #f85959;
    padding: 7px 10px;
    border-radius: 35px;
    letter-spacing: 2px;
}
.text-white, .line-white, .lines-white {
    color: #ffffff;
}
.comp {
  font-size: 30px;
  margin: 20px 20px;
  align-items:center;
}

.dbg {
  background: url(/img/bg.jpg);
}
page {
    background: #eeeeee;
}

.meitou {
    height: 160px;
    position: fixed;
    z-index: 999;
    width: 750px;
    background: linear-gradient(to right, #2a8af7, #680ef8);
}

.class-v {
    width: 100%;
    height: 176px;
    /* margin: 30px; */
    padding: 60px 60px 0px 30px;
    /* position: relative; */
    display: flex;
    /* background: #ffffff; */
    background: rgb(245, 246, 250);
    /* border-radius: 30px; */
}

.class-img {
    /* display: inline-block; */
    width: 750px;
    height: 450px;

}

.class-t {
    padding: 20px 30px;
    /* background: #ffffff; */

}

.class-name {
    padding: 30px 30px 20px 30px;
    /* top: -46px; */
    font-size: 36px;
    font-weight: 600;
    width: 750px;
}

.class-gx {
    color: rgb(148, 147, 147);
    font-size: 25px;
    margin-top: 13px;
}

.class-rd {
    color: rgb(148, 147, 147);
    font-size: 25px;
    /* margin-top: 4px; */
}

.class-mm {
    /* top: 45px; */
    display: flex;
    position: absolute;
    right: 69px;
    bottom: 0px;
}

.class-pay {
    color: white;
    font-size: 40px;
}

.yue {
    /* margin-top: 30px; */
    /* width: 100%; */
    /* height: 88px; */
    background: #FFFFFF;
    padding: 20px 0px 1px 0px;
    /* margin: 30px 0 0 30px; */
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #d1d0d0;
}

.bz {
    color: #ffffff;
    background: rgb(49, 49, 247);
    padding: 3px 4px 3px 4px;
    border-radius: 3px;

}

.zeng {
    color: #e91c1c;
    border: 2px solid #e91c1c;
    padding: 2px 3px 2px 3px;
    border-radius: 3px;

}

.zeng-img {
    /* border-radius: 50%; */
    width: 20px;
    height: 20px;
}

.xfbz {
    font-size: 15px;
    color: rgb(0, 0, 0);
}

.teacher {
    margin: 10px 0;
    /* width: 100%; */
    /* height: 88px; */
    letter-spacing: 2px;
    background: white;
    border-radius: 16px;
    padding: 20px 0 30px 0;

}

/* .teacher-info {
    height: 36px;
} */

.teacher-img {
    /* background-color: #2a8af7; */
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 30px;
}

.teacher-name {

    font-weight: 500;
    line-height: 29px;
    font-size: 33px;
    /* margin-top: 10px; */
}

.teacher-js {
    /* height: 36px; */
    border-top: 1px solid #d1d0d0;
    font-size: 30px;
    line-height: 45px;
    font-weight: 300;
    margin: 0 30px;
}

.downp {
    background-color: #FFFFFF;
}

.nav .cu-item {
    height: 90px;
    display: inline-block;
    line-height: 90px;
    margin: 0 10px;
    padding: 0 13px;
}

.nav .cu-item.cur {
    border-bottom: 4px solid;
}

.cu-bar.fixed,
.nav.fixed {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1024;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
}

.nav {
    width: 97%;
    height: 87px;
    line-height: 35px;
    background: #ffffff;
    display: inline-block;
    margin-top: 20px;
}

.cu-item {
    text-align: center;
    display: inline-block;
    min-width: 160px !important;
    color: #999999;
    /* display: flex !important; */
    align-items: center !important;
    justify-content: center !important;
    font-size: 31px;
    font-weight: bolder;
}

.on1::after {
    text-align: center;
    min-width: 130px;
    height: 8px;
    background-color: #90d6f6;
    border-radius: 4px;
    content: "";
    position: absolute;
    top: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 20px;
    opacity: 0.8;
}

.on2::after {
    text-align: center;
    width: 170px;
    height: 8px;
    background-color: #3ea4f8;
    border-radius: 4px;
    content: "";
    position: absolute;
    top: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 20px;
    opacity: 0.8;
    /* border-bottom: 2px solid #405cfd !important; */
}

.on {
    color: #000;
    font-size: 40px;

}

.xq-detail {
    background: rgb(245, 246, 250);
    margin: 30px;
    border: 1px solid rgb(222, 223, 224);
    border-radius: 10px;
    font-size: 32px;
}

.xq-js {
    text-align: center;
    height: 60px;
    line-height: 60px;
}

.xq-li {
    display: flex;
    border-top: 1px solid rgb(222, 223, 224);
    height: 60px;
    line-height: 60px;
}

.xq-title {
    text-align: center;
    border-right: 1px solid rgb(222, 223, 224);
    padding: 0 50px;
    width: 250px !important;
}

.xq-info {
    color: rgb(157, 159, 160);
    padding: 0 50px;
    width: 66%;
    text-align: center;
}

.xq-pj {
    margin-top: 30px;
    width: 100%;
    height: 88px;
    background: #FFFFFF;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    padding: 30px;
    display: flex;
    justify-content: space-between;
}

.xq-pj-1 {
    font-size: 35px;
    font-weight: 500;
}

.xq-pj-11 {
    color: #999999;
}

.xq-pj-2 {
    color: rgb(23, 83, 248);
    font-size: 25px;
}

.teacher-n {
    margin-left: 106px;
    font-weight: 500;
    line-height: 25px;
    font-size: 30px;
    color: #999999;
    margin-top: 10px;
}

.teacher-say {
    margin-left: 106px;
    font-weight: 500;
    line-height: 25px;
    font-size: 30px;
    margin-top: 30px;
}

.teacher-time {
    margin-left: 106px;
    font-weight: 500;
    line-height: 25px;
    font-size: 25px;
    color: #999999;
}

.user-s {
    padding: 30px;
}

.user-img {
    position: absolute;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    left: 15px;
    top: 13px;
}

.tip {
    font-size: 35px;
    font-weight: 500;
    padding: 30px;
    color: #000;
    text-align: center;
}

.tip-d {
    margin: 30px;
    border: 1px solid rgb(222, 223, 224);
    padding: 25px;
    border-radius: 15px;
}

.tip-title {
    display: flex;
    font-size: 30px;
    font-weight: 600;
    line-height: 25px;
}

.tip-img {
    width: 50px;
    height: 50px;
    display: inline-block;
}

.tip-info {
    font-size: 25px;
    line-height: 43px;
    color: #696969;
}

.pay-area {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #FFFFFF;
    padding: 25px;
    height: 120px;
    z-index: 9;
}

.tb-area1 {
    font-size: 18px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #999999;
    line-height: 23px;
    display: inline-block;
    /* position: absolute;
    left: 71px;
    bottom: 28px; */
}

.tb-area2 {
    font-size: 18px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #999999;
    line-height: 23px;
    display: inline-block;
    /* position: absolute;
    left: 40px;
    bottom: 28px; */
}

.dp-img {
    width: 45px;
    height: 42px;
    background: white;
}

.cu-btn {
    position: relative;
    border: 0px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    font-size: 28px;
    height: 61px;
    line-height: 1;
    text-align: center;
    text-decoration: none;
    overflow: visible;
    margin-left: initial;
    transform: translate(0px, 0px);
    margin-right: initial;
}

radio {
    transform: scale(0.8);
    color: #ffffff !important;
    /* background-color: #1296db !important; */
}

.btn-gm {
    /* width: 232px !important; */
    height: 65px !important;
    background: linear-gradient(to right, #2a8af7, #680ef8) !important;
    border-radius: 30px;
    /* position: absolute;
    right: 30px;
    bottom: 30px; */
    padding: 23px !important;
}

.btn-font {
    font-size: 30px;
    font-family: PingFang SC;
    color: #FFFFFF;
    line-height: 26px;
}

.course-num {
    padding: 5px 10px 5px 10px;
    margin: 30px;
    color: blue;
    border-radius: 35px;
    min-width: 90px;
    max-width: 108px;
    text-align: center;
    border: 1px solid blue;
}

.course-detail {
    display: flex;
    margin: 30px;
    border-bottom: 1px solid rgb(222, 223, 224);
    padding-bottom: 30px;
    /* height: 70px; */
}

.course-detail-n {
    /* width: 10%; */
    line-height: 70px;
}


.course-title {
    font-size: 30px;
}

.course-type {
    padding: 3px;
    border: 1px solid #999999;
    border-radius: 5px;
}

.course-time {
    color: #999999;
    top: 20px;
}

.course-play {
    /* position: absolute;
    right: 10px;
    top: 20px; */
    border-radius: 30px;
    background: rgb(216, 225, 243);
    padding: 5px 10px 5px 10px;
    width: 20%;
    font-size: 23px;
    display: flex;
    color: #1296db;
    line-height: 16px;
}

.course-img1 {
    width: 20px;
    height: 20px;

}

.course-img {
    width: 14px;
    height: 14px;

}

.ensure-sha {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    background: black;
    opacity: 0.6;
    z-index: 9;
}

.ensure-info {
    z-index: 99;
    background: #ffffff;
    min-height: 420px;
    position: fixed;
    width: 100%;
    bottom: 0px;
    padding: 30px;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
}

.tan2 {
    z-index: 99;
    background: #ffffff;
    min-height: 420px;
    position: fixed;
    width: 100%;
    bottom: 0px;
    padding: 0px;
    border-top-left-radius: 30px;
}

.ensure-fff {

    background: #ffffff;
    min-height: 420px;

    padding: 30px;
    border-radius: 30px;
}

.ensure-t {
    text-align: center;
    font-size: 35px;
    font-weight: 550;
}

.zeng-bg {
    background: #c92d2d;
    color: #fff;
    text-align: center;
    font-size: 35px;
    font-weight: 550;
    padding: 30px;
    border-radius: 20px 0 0 0;
}

.ensure-detail {
    display: flex;
    margin: 30px;
    padding-bottom: 30px;
    height: 70px;
}

.ensure-detail-n {
    width: 20%;
    /* line-height: 70px; */
    border-top: 10px;
}

.ensure-info2 {
    width: 80%;
}

.ensure-title {
    font-size: 30px;
    font-weight: 550;
}

.ensure-time {
    /* color: #999999; */
    font-weight: 300;
    /* top: 20px; */
}

.ensure-detail-img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 1px solid #1296db;
}

.blue-t {
    color: blue;
}

.tip-img1 {
    width: 30px;
    height: 30px;
    display: inline-block;
    margin: 3px;
    margin-top: -5px;
}

/* 弹幕 */

.item-ranking {
    margin: 0 30px 30px 30px;
    border-radius: 30px;
    padding: 0 30px 30px 30px;
}


.paihangimg {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    margin: 0 10px 0 0;
}

/* 划线价格 */
.huaxianjia {
    color: #ffffff;
    font-size: 24px;
    padding-top: 58px;
    text-decoration: line-through;
}

.xuanfu-tvimg {
    width: 130px;
    height: 125px;
    position: fixed;
    bottom: 460px;
    z-index: 9999;
    right: 35px;
}

.x-shu {
    width: 2px;
    height: 20px;
    margin: 0 19px;
    background-color: #dddddd;
}

.more {
    background-color: rgb(60, 141, 247);
    padding: 10px 35px;
    border-radius: 30px;
    color: #ffffff;
    font-size: 22px;
}

.more1 {
    background-color: #fff;
    padding: 0px 30px;
    border-radius: 30px;
    color: #2323f8;
    font-size: 22px;
}

.user-ch {
    display: inline-block;
    font-size: 25px;
    color: #2323f8;
    background: rgb(233, 233, 253);
    padding: 2px 10px;
    border-radius: 10px;
    margin: 20px 15px 0 0;
}

/* ::before, ::before, ::before, ::before {
    font-family: "cuIcon";
    content: "\e645";
    position: absolute;
    color: var(--white) !important;
    top: 50%;
    margin-top: -8px;
    right: 2px;
    font-size: 17px;
    line-height: 16px;
    pointer-events: none;
    transform: scale(1, 1);
    transition: all 0.3s ease-in-out 0s;
    z-index: 9;
} */


.dingdan-xf {
    width: 95%;
    position: fixed;
    bottom: 230px;
    background-color: #2a8af7;
    border-radius: 20px;
    z-index: 9;
}

.dongtu-img {
    height: 90px;
    width: 90px;
}

.pdd {
    padding: 0 10px 0 10px;
}

.bg-skugou {
    background: linear-gradient(to right, #2a8af7, #680ef8) !important;
}

.kec-img {
    height: 155px;
    box-sizing: 20px;
    width: 230px;
    border-radius: 10px;
    background-color: rgb(178, 185, 236);
}

.good-name {
    font-size: 34px;
    font-weight: bold;

}
.text-blue,
.line-blue,
.lines-blue {
	color: #0081ff;
}
.bg-blue {
  background-color:#0081ff;
  color: #ffffff;
}
.zxy {
    font-size: 28px;
    color: #999999;
    text-align: center;
    line-height: 50px;
    padding-bottom: 30px;
}
.padding-xs {
    padding: 10px;
}
</style>
